export default __webpack_public_path__ + "static/media/s-6.e6591cda.jpg";